/* global FontFaceObserver */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (window.FontFaceObserver !== undefined) {
      var font = new FontFaceObserver('proxima-nova', {
        weight: 400
      });
      font.load(null, 15000).then(function () {
        document.documentElement.classList.add('fonts-loaded');
      }, function () {
        document.documentElement.classList.add('fonts-not-loaded');
      });
    }
  }
})();
/* global loadJS, LazyLoad */
(function () {
  var classList = document.documentElement.classList;

  function loadLazyLoad() {
    loadJS('/js/lazyload/lazyload.min.js', function () {
      return new LazyLoad({
        elements_selector: '.lazy'
      });
    });
  }

  if (classList.contains('no-promises')) {
    loadJS('/js/polyfills/polyfill.min.js', true);
  }
  /*
  if (classList.contains('no-objectfit')) {
      loadJS('/js/polyfills/objectFitPolyfill.min.js', true)
  }
  */


  if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    document.documentElement.classList.add('no-intersectionobserver');
    loadJS('/js/polyfills/intersection-observer.js', loadLazyLoad);
  } else {
    document.documentElement.classList.add('intersectionobserver');
    loadLazyLoad();
  }
  /*
  if (classList.contains('no-fetch')) {
      loadJS('/js/polyfills/fetch.umd.js')
  }
  */

})();
require("core-js/modules/es.set.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.regexp.exec.js");

/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
var mouseoverTimer;
var lastTouchTimestamp;
var prefetches = new Set();
var prefetchElement = document.createElement('link');
var isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch') && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype;
var allowQueryString = ('instantAllowQueryString' in document.body.dataset);
var allowExternalLinks = ('instantAllowExternalLinks' in document.body.dataset);
var useWhitelist = ('instantWhitelist' in document.body.dataset);
var mousedownShortcut = ('instantMousedownShortcut' in document.body.dataset);
var DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
var delayOnHover = 65;
var useMousedown = false;
var useMousedownOnly = false;
var useViewport = false;

if ('instantIntensity' in document.body.dataset) {
  var intensity = document.body.dataset.instantIntensity;

  if (intensity.substr(0, 'mousedown'.length) == 'mousedown') {
    useMousedown = true;

    if (intensity == 'mousedown-only') {
      useMousedownOnly = true;
    }
  } else if (intensity.substr(0, 'viewport'.length) == 'viewport') {
    if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g')))) {
      if (intensity == "viewport") {
        /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
         * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
         * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 450000) {
          useViewport = true;
        }
      } else if (intensity == "viewport-all") {
        useViewport = true;
      }
    }
  } else {
    var milliseconds = parseInt(intensity);

    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds;
    }
  }
}

if (isSupported) {
  var eventListenersOptions = {
    capture: true,
    passive: true
  };

  if (!useMousedownOnly) {
    document.addEventListener('touchstart', touchstartListener, eventListenersOptions);
  }

  if (!useMousedown) {
    document.addEventListener('mouseover', mouseoverListener, eventListenersOptions);
  } else if (!mousedownShortcut) {
    document.addEventListener('mousedown', mousedownListener, eventListenersOptions);
  }

  if (mousedownShortcut) {
    document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions);
  }

  if (useViewport) {
    var triggeringFunction;

    if (window.requestIdleCallback) {
      triggeringFunction = function triggeringFunction(callback) {
        requestIdleCallback(callback, {
          timeout: 1500
        });
      };
    } else {
      triggeringFunction = function triggeringFunction(callback) {
        callback();
      };
    }

    triggeringFunction(function () {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var linkElement = entry.target;
            intersectionObserver.unobserve(linkElement);
            preload(linkElement.href);
          }
        });
      });
      document.querySelectorAll('a').forEach(function (linkElement) {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement);
        }
      });
    });
  }
}

function touchstartListener(event) {
  /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
   * must be assigned on touchstart to be measured on mouseover. */
  lastTouchTimestamp = performance.now();
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  linkElement.addEventListener('mouseout', mouseoutListener, {
    passive: true
  });
  mouseoverTimer = setTimeout(function () {
    preload(linkElement.href);
    mouseoverTimer = undefined;
  }, delayOnHover);
}

function mousedownListener(event) {
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
    return;
  }

  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = undefined;
  }
}

function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }

  if (!linkElement) {
    return;
  }

  linkElement.addEventListener('click', function (event) {
    if (event.detail == 1337) {
      return;
    }

    event.preventDefault();
  }, {
    capture: true,
    passive: false,
    once: true
  });
  var customEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
    detail: 1337
  });
  linkElement.dispatchEvent(customEvent);
}

function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return;
  }

  if (useWhitelist && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!allowExternalLinks && linkElement.origin != location.origin && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!['http:', 'https:'].includes(linkElement.protocol)) {
    return;
  }

  if (linkElement.protocol == 'http:' && location.protocol == 'https:') {
    return;
  }

  if (!allowQueryString && linkElement.search && !('instant' in linkElement.dataset)) {
    return;
  }

  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return;
  }

  if ('noInstant' in linkElement.dataset) {
    return;
  }

  return true;
}

function preload(url) {
  if (prefetches.has(url)) {
    return;
  }

  var prefetcher = document.createElement('link');
  prefetcher.rel = 'prefetch';
  prefetcher.href = url;
  document.head.appendChild(prefetcher);
  prefetches.add(url);
}
require("core-js/modules/web.timers.js");

/* global $ */

/* global jQuery */

/* global loadJS */
jQuery(function () {
  $.nette.init();
  $('body').on('click', '.confirm', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var text = $(this).data('confirm-text');

    if (confirm(text ? '' + text : $('html').attr('lang') === 'cs' ? 'Opravdu smazat tento záznam?' : 'Do you really want to delete this record?')) {
      document.location = $(this).attr('href');
    }
  });

  if ($('#ajaxSpinner').length > 0) {
    $(document).on('ajaxStart', function () {
      $('#ajaxSpinner').addClass('loading');
    });
    $(document).on('ajaxStop', function () {
      $('#ajaxSpinner').removeClass('loading');
    });
  } // DYNAMIC GRECAPTCHA LOADER

  /*
  var grecaptchaLoading = false
  if ($('form .g-recaptcha').length > 0) {
      if (window.grecaptcha === undefined) {
          $('form input').on('focus', function() {
              if (!grecaptchaLoading && window.grecaptcha === undefined) {
                  grecaptchaLoading = true
                  loadJS('/js/recaptcha/recaptcha.invisible.ajax.js', function () {
                      grecaptchaLoading = false
                  })
              }
          })
      }
  }
    if ($('form.load-grecaptcha').length > 0) {
      if (window.grecaptcha === undefined) {
          if (!grecaptchaLoading && window.grecaptcha === undefined) {
              grecaptchaLoading = true
              loadJS('/js/recaptcha/recaptcha.invisible.ajax.js', function () {
                  grecaptchaLoading = false
              })
          }
      }
  }
  */
  // IFRAME SRC TOGGLE


  (function () {
    var tm;
    $('body').on('click', 'a[data-toggle-iframe]', function (event) {
      var el = $(event.target);
      var iframe = $(el.data('iframe'));

      if (iframe.length === 1) {
        clearTimeout(tm);
        iframe.attr('src', '');
        tm = setTimeout(function () {
          iframe.attr('src', el.data('iframe-src'));
        }, 100);
      }
    });
  })();
});
require("core-js/modules/es.array.is-array.js");

/* global toastr */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    document.body.classList.add('site-onready');
    setToastrDefaults();
    showFlashMessages();
  }

  function setToastrDefaults() {
    if (Object.prototype.hasOwnProperty.call(window, 'toastr')) {
      toastr.options = {
        'closeButton': true,
        'progressBar': true
      };
    }
  }

  function showFlashMessages() {
    if (window._cmsFlashMessages !== undefined && Array.isArray(window._cmsFlashMessages) && window._cmsFlashMessages.length > 0) {
      for (var index in window._cmsFlashMessages) {
        var item = window._cmsFlashMessages[index];

        switch (item.type) {
          case 'success':
            toastr.success(item.message);
            break;

          case 'error':
            toastr.error(item.message);
            break;

          case 'warning':
            toastr.warning(item.message);
            break;

          default:
            toastr.info(item.message);
        }
      }

      window._cmsFlashMessages = [];
    }
  }

  window.dataLayer = window.dataLayer || [];
})();
/* global SmoothScroll */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (window.SmoothScroll !== undefined) {
      /* eslint-disable-next-line no-unused-vars */
      var scroll = new SmoothScroll('a[data-scroll][href*="#"]');
    }
  }
})();
require("core-js/modules/web.timers.js");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var tm;
  var prevPosition = 0;
  var position = 0;

  function checkStickyMenu() {
    position = window.pageYOffset;
    var body = document.body;
    var isActive = body.classList.contains('sticky-header');

    if (position > 150) {
      if (!isActive) {
        body.classList.add('sticky-header-no-transition');
        setTimeout(function () {
          body.classList.remove('sticky-header-no-transition');
        }, 50);
        body.classList.add('sticky-header');
      }

      if (position - prevPosition < 0 && isActive) {
        body.classList.add('sticky-header-up');
      } else {
        body.classList.remove('sticky-header-up');
      }
    } else {
      body.classList.remove('sticky-header-no-transition');
      body.classList.remove('sticky-header');
      body.classList.remove('sticky-header-up');
    }

    prevPosition = position;
  }

  function run() {
    document.addEventListener('scroll', function (event) {
      clearTimeout(tm);
      tm = setTimeout(checkStickyMenu, 25);
    });
    checkStickyMenu();
  }
})();
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (window.SimpleLightbox !== undefined) {
      var lightbox = new SimpleLightbox('.image-lightbox-link', {});
    }
  }
})();